export const EditRequestTemplateDefaultValue = (data) => {
  return {
    activities: data?.activities,
    service_ids: data?.services,
    name: data?.name
  };
};

export default EditRequestTemplateDefaultValue;
